import React, { useCallback, useState } from "react";
import { DropdownButton, Text } from "@jsq/ds/core";
import { PaymentStatus } from "../../../graphql/supergraphTypes";
import MarkAsFailedModal from "../MarkAsFailedModal";
import { dropdownButton } from "./styles_vanilla.css";

interface PositionActionMenuProps {
  paymentId: string;
  payeeName: string;
  paymentStatus: PaymentStatus;
  onPaymentUpdated?: () => void;
}

const PositionActionMenu: React.FC<PositionActionMenuProps> = ({
  paymentId,
  payeeName,
  paymentStatus,
  onPaymentUpdated,
}) => {
  const [showMarkAsFailedModal, setShowMarkAsFailedModal] = useState(false);

  const isMarkAsFailedEnabled = paymentStatus === "PROCESSING" || paymentStatus === "SETTLED";

  const handleMarkAsFailedClick = useCallback(() => {
    if (isMarkAsFailedEnabled) {
      setShowMarkAsFailedModal(true);
    }
  }, [isMarkAsFailedEnabled]);

  const handleModalClose = useCallback(() => {
    setShowMarkAsFailedModal(false);
  }, []);

  return (
    <>
      <MarkAsFailedModal
        paymentId={paymentId}
        payeeName={payeeName}
        show={showMarkAsFailedModal}
        onHide={handleModalClose}
        onSuccess={onPaymentUpdated}
      />
      <DropdownButton
        data-testid="position-action-menu"
        icon="ellipsis-h"
        variant="muted"
        align="right"
        direction="down"
        usePortal
      >
        <DropdownButton.Action
          onSelect={handleMarkAsFailedClick}
          disabled={!isMarkAsFailedEnabled}
        >
          <Text className={dropdownButton}>Mark as failed</Text>
        </DropdownButton.Action>
      </DropdownButton>
    </>
  );
};

export default PositionActionMenu;
